import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const boxStyles = {
  alignItems: 'center',
  borderRadius: '2px',
  display: 'flex',
  height: 20,
  justifyContent: 'center',
  width: 25,
};

const SelectorCardCount = ({ label, isActive, value }) => {
  const activeClass = isActive ? 'active' : 'inactive';

  return (
    <Stack alignItems="center" direction="row" gap={1}>
      <Box className={activeClass} sx={boxStyles}>
        <Typography variant="caption">{value}</Typography>
      </Box>
      <Typography variant="body2">{label}</Typography>
    </Stack>
  );
};

SelectorCardCount.propTypes = {
  isActive: PropTypes.bool,
  label: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
};
SelectorCardCount.defaultProps = {
  isActive: false,
};

export default SelectorCardCount;
